import TableChartIcon from '@mui/icons-material/TableChart';
import { Popover } from '@mui/material';
import { ReactElement, useCallback, useState } from 'react';
// Button does not require permissions
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Button, useTranslate } from 'react-admin';

import { SelectColumnsMenu } from '@sh4res/bo-common/components/SelectColumnsMenu';

type CurrentTarget = EventTarget & HTMLButtonElement;
interface SelectColumnsButtonProps<T extends Record<string, unknown>> {
  preference: string;
  defaultColumns: (keyof T)[];
  columns: Record<keyof T, ReactElement>;
  children?: ReactElement;
  testId: string;
}

export const SelectColumnsButton = <T extends Record<string, unknown> = Record<string, unknown>>({
  preference,
  columns,
  children,
  defaultColumns,
  testId,
  ...rest
}: SelectColumnsButtonProps<T>) => {
  const [anchorEl, setAnchorEl] = useState<null | CurrentTarget>(null);
  const translate = useTranslate();

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>): void => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const handleClose = useCallback((): void => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  return (
    <>
      <Button
        color="primary"
        onClick={handleClick}
        label={translate('ra-preferences.action.choose_columns')}
        disableElevation={true}
        data-testid={testId}
        {...rest}>
        {children || <TableChartIcon />}
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        <SelectColumnsMenu<T>
          preference={preference}
          columns={columns}
          defaultColumns={defaultColumns}
        />
      </Popover>
    </>
  );
};
